import { isEmpty } from 'lodash'
import DetailNegotationView from 'tennders-market/offer/views/DetailNegotationView'
import { STATUS_CANCELLED, STATUS_WAITING_FOR_OFFER } from 'tennders-stracture/libs/constants'
import InternalOffers from 'tennders-market/offer/components/InternalOffers'
import DetailDocuments from 'tennders-documents/views/DetailDocuments'
import DetailLog from 'tennders-transactions/views/log/DetailLog'
import React from 'react'

const DetailView = (props) => {
  const { transaction, isFixed } = props
  if (isFixed && !isEmpty(isFixed)) {
    return null
  }

  return (
    <>
      {transaction?.isOfferable && !transaction.isShared && <DetailNegotationView />}
      {(!transaction?.isOfferable && transaction?.status?.label === STATUS_WAITING_FOR_OFFER) && <InternalOffers />}
      {(transaction?.bookedBy || transaction?.status?.label === STATUS_CANCELLED) && (!transaction?.isOfferable || transaction?.status?.label !== STATUS_WAITING_FOR_OFFER) && (
        <DetailDocuments transaction={transaction} />
      )}
      <DetailLog />
    </>
  )
}
export default React.memo(DetailView)
